import * as React from "react";
import { Button as AntButton } from 'antd';

import { IBaseProps } from "lib/data/interfaces";
import './RightsEditButton.less';
import { AuthorizedComponent } from "components/general/AuthorizedComponent";


interface IRightsEditButtonProps extends IBaseProps {
	tooltip?: string;
	onClick?: (event: React.SyntheticEvent) => void
}



export const RightsEditButton = (props: IRightsEditButtonProps) =>
<AuthorizedComponent>
	<div className="rights-button-wrapper">
		<AntButton onClick={props.onClick} type="default" className="setting-button" shape="circle" icon="setting" size={"small"} />
	</div>
</AuthorizedComponent>
